import moment from 'moment';
import { useUser } from 'src/components/common/hooks/useUser';

export const usePreferedDateFormat = () => {
    const { preferences } = useUser();
    const userPreferedDateFormat: string = preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy';
  
    const preferedFormatForDatePicker = (date: any) => {
      if (date === null || date === "") {
        return null;
      }
      const convertedDate = moment(new Date(date)).format(userPreferedDateFormat.toUpperCase());
      const momentDate = moment(convertedDate,userPreferedDateFormat.toUpperCase()).toDate();
      return momentDate;
    };
  
    const preferedDateFormat = (date: any) => {
      if (date === null || date === "") {
        return null;
      }
      const convertedDate = moment(new Date(date)).format(userPreferedDateFormat.toUpperCase());
      if (convertedDate !== 'Invalid date') {
        return convertedDate;
      } else {
        return date;
      }
    };
  
    const getCurrentDateInPreferedFormat = () => {
      return moment(new Date()).format(userPreferedDateFormat.toUpperCase());
    };
  
    return { preferedFormatForDatePicker, preferedDateFormat, userPreferedDateFormat, getCurrentDateInPreferedFormat };
  };
  
